define('uikit/collections/search.results',['require','exports','module','underscore','jquery','marionette','../mixins/component.mixin','../templates'],function(require, exports, module){
  var _ = require('underscore');
  var $ = require('jquery');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('../templates');

  var ResultView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'result',

    tagName: 'li',

    attributes: {
      role: 'none presentation'
    },

    options: {
      active : false,
      description: '',
      text : ''
    },

    forceUpdate: {
      active: true
    },

    ui: {
      text: '.title',
      description: '.description'
    },

    triggers: {
      'mousedown' : 'selected'
    },

    template: Templates.UIKit['result'],

    updateAttributes: function() {
      this.addClass('active', this.getBoolOption('active'));
      if (this.ui.description) {
        this.ui.description.text(this.getOption('description'));
      }
      if (this.ui.text) {
        this.ui.text.text(this.getOption('text'));
      }
    }

  });

  var SearchResults = Mn.CollectionView.extend(ComponentMixin).extend({

    tagName: 'ul',

    attributes: {
      role: 'listbox'
    },

    className: 'results',

    childView: ResultView,

    options: {
      collection: null,
      empty: true
    },

    forceUpdate: { collection: true, empty: true },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      // Initial empty property set
      this.updateEmptyProperty();

      // Listener to select the first result, anytime the collection is rendered or a child view is removed or added
      this.listenTo(this, 'add:child remove:child render:collection', _.debounce(this.selectFirstResult));
    },

    getSelected: function() {
      return this.active;
    },

    /**
     * Select the clicked result,
     * and then propagate the selection of the result
     */
    onChildviewSelected: function(v) {
      this.selectResult(v._index);
      this.triggerMethod('result:selected', v);
    },


    /**
     *  Select the result at the given index
     *
     *  @param {Int} index          index of the result to be set to active
     *  @param {Boolean} ignoreSet  flag used to indicate whether to trigger event for setting a result active
     */
    selectResult: function(index, ignoreSet) {
      var result = null;

      // Find the result view at the passed index
      if (this.collection && this.collection.models[index]) {
        result = this.children.findByModel(this.collection.models[index]);
      }

      // Deselect all the results, except the next result chosen for selection
      this.children.without(result).forEach(function(c) {
        c.active = false;
      });

      // Set the result's active flag to true
      if (result) {
        result.active = true;

        this.scrollResultIntoView(result);
      }

      // Cache the active result
      this.active = result;

      // Trigger event when a result has been selected as active
      if (!ignoreSet) {
        this.triggerMethod('result:active', result);
      }
    },

    /**
     * Changes scrollTop of main view, depending on the position of the item
     * @param  {SearchResultView} result
     */
    scrollResultIntoView: function(result) {
      var itemHeight        = result.$el.outerHeight(),
          itemPosTop        = result.$el.position().top,
          itemPosBottom     = itemPosTop + itemHeight,

          listHeight        = this.$el.height(),
          listScrollTop     = this.$el.scrollTop();

      // Item is hiding below the results view
      if (itemPosBottom > listHeight) {
        // Scroll enough to show the rest of the item
        var scrollMore = itemHeight - (listHeight - itemPosTop);

        this.$el.scrollTop(listScrollTop + scrollMore);

      // Item is hiding above the results view
      } else if (itemPosTop < 0) {
        // Decrement the scrolling by the negative position of the item
        this.$el.scrollTop(listScrollTop + itemPosTop);
      }
    },

    /**
     *  Select the active result's next sibling,
     *  if there is no active result, select the first result,
     *  if there is no next sibling, do nothing
     */
    selectNextResult: function() {
      var active = this.active,
          index    = 0;

      if (active) {
        // Retrieve index of the active result's next sibling
        index = this.collection.indexOf(active.model) + 1;
      }

      if (index < this.children.length) {
        this.selectResult(index);
      }
    },

    /**
     *  Select the active result's previous sibling,
     *  otherwise clear any selection
     */
    selectPreviousResult: function () {
      var active = this.active,
          index  = null;

      if (active) {
        // Retrieve index of the active result's previous sibling
        index = this.collection.indexOf(active.model) - 1;
      }

      this.selectResult(index);
    },

    /**
     *  Set the first result as active, don't trigger any event
     */
    selectFirstResult: function() {
      // Reset active flag
      this.active = null;

      // Only select the first result, if items in the collections
      if (!_.isEmpty(this.collection)) {
        this.selectResult(0, true);
      }
    },

    /**
     *  Create listeners to update the empty flag, used to hide the results view
     */
    onChangeCollection: function(self, newCollection, oldCollection) {
      // Reset scroll bar
      this.$el.scrollTop(0);

      // Remove any possible old listener
      if (oldCollection) {
        this.stopListening(oldCollection);
      }

      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset update', _.debounce(this.updateEmptyProperty))
      }

      this.updateEmptyProperty();
    },

    /**
     *  Empty flag use to hide the results dropdown, if there is nothing to show
     *  Allows for addition of footer or header not included in the collection
     */
    updateEmptyProperty: function() {
      this.empty = !this.collection || this.collection.isEmpty();
    },

    updateAttributes: function() {
      this.addClass('empty', this.getBoolOption('empty'));
      if (this.getBoolOption('empty')) {
        this.updateElementAttributes({'aria-hidden': true});
      } else {
        this.removeElementAttribute('aria-hidden');
      }
    }

  });

  SearchResults.Result = ResultView;

  module.exports = SearchResults;

});

